import { FC } from 'react'
import { MdDarkMode, MdLightMode } from 'react-icons/md'
import SlideInMotion, { SlideInDirection } from './SlideInMotion'
import logo from '../assets/logo.svg'
import logoDark from '../assets/logo-dark.svg'
import * as nav from '../styles/Nav.styled'
import * as layout from '../styles/Layout.styled'
import * as title from '../styles/Title.styled'
import { baseTheme } from '../styles/theme'
import useMediaQuery from '../hooks/useMediaQuery'
import { useAppDispatch, useAppSelector } from '../app/hooks'
import { toggleThemeMode } from '../features/theme/themeSlice'
import { Section, ThemeMode } from '../typing/enums'
import { MyMouseEvent, MyRefObject } from '../typing/types'
import { NavProps } from '../typing/interfaces'

export const Header: FC<NavProps> = ({
  aboutSection,
  portfolioSection,
}) => {
  const dispatch = useAppDispatch()

  const themeMode = useAppSelector(state => state.theme.mode)

  const isSmallScreen = useMediaQuery(`(max-width: ${baseTheme.screen.small})`)

  const scrollToSection = (e: MyMouseEvent, ref: MyRefObject) => {
    e.preventDefault()

    const headerSize = isSmallScreen
      ? baseTheme.sizes.smallHeader
      : baseTheme.sizes.header

    const offset = ref.current?.offsetTop || 0

    window.scrollTo({
      top: offset - parseInt(headerSize),
      behavior: 'smooth',
    })
  }

  return (
    <layout.StyledHeader>
      <title.StyledContainer>
        <SlideInMotion direction={SlideInDirection.left}>
          <title.StyledIcon
            src={(themeMode === ThemeMode.dark) ? logoDark : logo}
            alt='logo'
          />
        </SlideInMotion>
        <SlideInMotion direction={SlideInDirection.right}>
          <title.StyledTextContainerMain>
            <title.StyledTextContainerOne>
              <title.StyledLineOne>Pour</title.StyledLineOne>
              <title.StyledLineOne>and</title.StyledLineOne>
              <title.StyledLineOne>Fire</title.StyledLineOne>
            </title.StyledTextContainerOne>
            <title.StyledTextContainerTwo>
              {
                ['P', 'O', 'T', 'T', 'E', 'R', 'Y']
                  .map((letter:string, index:number) => (
                    <title.StyledLineTwo key={index}>
                      {letter}
                    </title.StyledLineTwo>
                  ))
              }
            </title.StyledTextContainerTwo>
          </title.StyledTextContainerMain>
        </SlideInMotion>
      </title.StyledContainer>
      <nav.StyledNav>
        <nav.StyledNavItem
          onClick={(e: MyMouseEvent) => scrollToSection(e, aboutSection)}
        >
          {Section.about}
        </nav.StyledNavItem>
        <nav.StyledNavSeparator>/</nav.StyledNavSeparator>
        <nav.StyledNavItem
          onClick={(e: MyMouseEvent) => scrollToSection(e, portfolioSection)}
        >
          {Section.portfolio}
        </nav.StyledNavItem>
        <nav.StyledThemeToggle
          onClick={() => dispatch(toggleThemeMode())}
          aria-label={(themeMode === ThemeMode.dark)
            ? 'Switch to light mode'
            : 'Switch to dark mode'}
          title={(themeMode === ThemeMode.dark)
            ? 'Switch to light mode'
            : 'Switch to dark mode'}
        >
          {
            (themeMode === ThemeMode.dark)
              ? <MdLightMode />
              : <MdDarkMode />
          }
        </nav.StyledThemeToggle>
      </nav.StyledNav>
    </layout.StyledHeader>
  )
}
